import { withMetrics } from '@atlassian/jira-forge-ui-analytics/src/common/ui/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const getModule = () =>
	import(
		/* webpackChunkName: "async-forge-ui-issue-view-extension" */ '@atlassian/jira-forge-issue-navigator-base/src/ui/extension/'
	);

export const LazyIssueNavigatorForgeExtension = withMetrics(
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint(() => getModule().then((module) => module.IssueNavigatorForgeExtension), {
		ssr: false,
	}),
);
